import React, { useEffect, useRef, useState } from 'react';
import printerIcon from "../../../../assets/images/connectdevice-printericon.svg";
import EcoProButton from '../../../shared/button/button';
import {
    GetBOCWebDeviceCapability,
    GetDeviceRegistration,
    ResetCodeSubmissionState,
    ResetOneTimeCodeError,
    ResetStateDashboardPreEnrolInfo
} from '../../../../actions/Web/Customer/SignUp';
import { useDispatch, useSelector } from 'react-redux';
import {
    WEB_handleLocalData,
    WEB_handleSelectedPlanLocalData,
    getLocalSessionData,
    getUserData,
    getUserDataByKey,
    getUserSessionData
} from '../../../../utils/Authentication/handleUserSession';
import {
    BOC_WEB_DEVICE_CAPABILITY_CODES,
    ECOPROTOKEN_CLAIMS,
    LOCALSESSIONDATAKEYS,
    UNIQUE_ID_GA,
    WEB,
    alphaNumericRegex
} from '../../../../constants/AppConstants';
import Loader from '../../../shared/loader/Loader';
import ErrorPage from '../../../shared/errorPage/ErrorPage';
import { FetchUserAccount } from '../../../../actions/UserAccount';
import { Enrollment } from '../../../../actions/MyAccount';
import { Trans, useTranslation } from 'react-i18next';
import {
    getContactUsLink,
    handleNavigateToAppStore,
    handleSubscriptionOrderPayload,
    Is_BrotherPlus_Signup,
    pushDataLayer
} from '../../../../constants/AppMethod';
import { getLangCode } from '../../../../utils/Internationalization/handleAppInternationalization';
import DeviceConnectedSuccessfullyImage from "../../../../assets/images/account-steps-completed-tick.svg"
import { DeviceNotConnected } from '../../../../pages/Web/Customer/Account/SignUp/Dashboard/ConnectDeviceDashboard';
import deviceOffline from '../../../../assets/images/printer-offline.svg';
import DisplayUpdateAccountConfirmation from '../../../EditMyAccount/DisplayUpdateAccountConfirmation/DisplayUpdateAccountConfirmation';
import UseAndroidIosAppIcons from '../../../../utils/CustomHooks/UseAndroidIosAppIcons';
import { EnrollmentRegisterServiceInit } from '../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice';
import { SOURCE_MY_DEVICE } from '../../../../pages/MyDevices/components/SuppliesComponent';
import PinError from './PinError';
import { updateUserNotificationConsentStateRequest } from '../../../../store/brotherPlus/UserNotificationConsent/UpdateUserNotificationConsentStateSlice';
import { evaluateConsent } from '../../../../utils/consentService';
import { getUserNotificationConsentDetailsRequest } from '../../../../store/brotherPlus/UserNotificationConsent/GetUserNotificationConsentDetailsSlice';
import useNavigateOnEnrollmentSuccess from './useNavigateOnEnrollmentSuccess';
import { useUserNotificationConsent } from '../../../../utils/CustomHooks/useUserNotificationConsent';
import { VerifyPreEnrollmentInfo } from '../../../../actions/Web/Customer/SignIn';

const WebConnection = (props) => {
    const {
        header,
        subcontent,
        instruction1,
        instruction2,
        instruction3,
        enterCodeLabel,
        codeSubmitText,
        cname,
        AddDeviceSetCurrentStepIndex,
        source,
        setIsDeviceSubmitted
    } = props

    const dispatch = useDispatch()
    const { t } = useTranslation(["translation"]);
    const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
    const AZURE_AD_B2C_UID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);

    const [oneTimeCode, setOneTimeCode] = useState("")
    const [showSuccessContent, setShowSuccessContent] = useState(false);
    const [showUnsupportedFirmware, setShowUnsupportedFirmware] = useState(false)
    const [showDeviceOffline, setShowDeviceOffline] = useState(false)
    const DeviceRegistrationResult = useSelector(state => state.GetDeviceRegistration)
    const BOCDeviceCapabilityResult = useSelector(state => state.GetBOCWebDeviceCapability)
    const zrenderParams = useSelector(state => state.ZuoraPaymentInfoRendering);
    const ScmsTokenResult = useSelector(state => state.SCMSTokenAuthentication)
    const UserAccount = useSelector((state) => state.UserAccount);
    const EnrollmentResponse = useSelector(state => state.Enrollment);
    const BrotherPlus_RegisterServiceResp = useSelector(state => state.BROTHERPLUS.RegisterService);    
    const langCode = getLangCode();
    const appIconsImgSrc = UseAndroidIosAppIcons(langCode);
    const SignupType = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);
    const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
    const {
        emailConsent,
        loading: getConsentLoading,
        error: getConsentError,
        success: getConsentSuccess,
    } = useUserNotificationConsent();
    const emailConsentRef = useRef(emailConsent);
    emailConsentRef.current = emailConsent;
    // Owns the navigation timer — prevents React effect cleanup from cancelling it mid-flight.
    const navTimerRef = useRef(null);
    // Tracks whether THIS journey dispatched the GET — prevents Effect 2 from
    const consentGetDispatched = useRef(false);
    // Tracks whether THIS journey dispatched the PATCH — prevents Effect 3 from
    // firing on stale putConsentSuccess/putConsentError left in Redux from a prior session.
    const consentUpdateDispatched = useRef(false);
    const {
        loading: putConsentLoading,
        success: putConsentSuccess, 
        error: putConsentError 
    } = useSelector((state) => state.BROTHERPLUS.updateUserNotificationConsentState);

    const navigateOnEnrollmentSuccess = useNavigateOnEnrollmentSuccess({
        source,
        setShowSuccessContent,
        AddDeviceSetCurrentStepIndex,
        navTimerRef,
    });

    const handleCodeSubmit = () => {
        pushDataLayer("web_BOC_enrollment", "printer_code_button", "submit");
        dispatch(ResetCodeSubmissionState());
        if (setIsDeviceSubmitted)
            setIsDeviceSubmitted(true);
        dispatch(GetDeviceRegistration(UID, oneTimeCode, source));
    }

    const contactUsLink = getContactUsLink()

    const handleOneTimeCode = (e) => {
        if (DeviceRegistrationResult.error || BOCDeviceCapabilityResult.error) {
            dispatch(ResetOneTimeCodeError())
        }
        const { value } = e.target
        if (value === "" || alphaNumericRegex.test(value)) {
            setOneTimeCode(e.target.value)
        }
    }
    const recheckNetworkStatus = () => {
        setShowDeviceOffline(false)
        const deviceId = DeviceRegistrationResult?.data?.deviceId
        const modelName = DeviceRegistrationResult?.data?.modelName
        dispatch(GetBOCWebDeviceCapability(UID, deviceId, modelName));
    }
    const DashboardPreEnrollInfo = useSelector(state => state.GetDashboardPreEnrollInfo);
    const VerifyPreEnrollmentInfoResp = useSelector((state) => state.VerifyPreEnrollmentInfo);    

    useEffect(() => {
        if (BOCDeviceCapabilityResult.success && DeviceRegistrationResult.success) {

            if (BOCDeviceCapabilityResult.bocDeviceCapability.customCode === BOC_WEB_DEVICE_CAPABILITY_CODES.UNSUPPORTED_FIRMWARE_VERSION.customeCode) {
                setShowUnsupportedFirmware(true)
            }
            else if (BOCDeviceCapabilityResult.bocDeviceCapability.customCode === BOC_WEB_DEVICE_CAPABILITY_CODES.DEVICE_OFFLINE.customeCode) {
                setShowDeviceOffline(true)
            }
            else {
                const deviceId = DeviceRegistrationResult?.data?.deviceId
                dispatch(FetchUserAccount(AZURE_AD_B2C_UID, UID, deviceId, SignupType, source));
            }
        }
    }, [
        dispatch,
        BOCDeviceCapabilityResult.success,
        DeviceRegistrationResult.success,
        DeviceRegistrationResult?.data?.deviceId,
        UID,
        AZURE_AD_B2C_UID,
        BOCDeviceCapabilityResult?.bocDeviceCapability?.customCode,
        SignupType,
        source
    ])

    useEffect( () => {
        if (
            UserAccount.success 
            && !Object.keys(VerifyPreEnrollmentInfoResp.data).length 
            && VerifyPreEnrollmentInfoResp.loading === false 
            && !IsBrotherPlus_Signup
            && source !== SOURCE_MY_DEVICE
            && Object.keys(DashboardPreEnrollInfo?.data).length) {
            const preEnrollmentDetails = {
                preEnrollId: DashboardPreEnrollInfo?.data?.preEnrollInfoViewModel?.id,
                PlanId: DashboardPreEnrollInfo?.data?.preEnrollInfoViewModel?.parameter?.planId,
                DiscountPlanIds: DashboardPreEnrollInfo?.data?.preEnrollInfoViewModel?.parameter?.discountPlanIds,
                deviceOption: DashboardPreEnrollInfo?.data?.preEnrollInfoViewModel?.deviceOption
            }
            dispatch(VerifyPreEnrollmentInfo(preEnrollmentDetails));
        }
    }, [
        dispatch, 
        DashboardPreEnrollInfo, 
        UserAccount, 
        VerifyPreEnrollmentInfoResp, 
        IsBrotherPlus_Signup,
        source
    ] )

    useEffect( () =>{
        if ( BOCDeviceCapabilityResult.success && UserAccount.success ) {
            if (( IsBrotherPlus_Signup || source === SOURCE_MY_DEVICE ) && (BrotherPlus_RegisterServiceResp.loading === false && BrotherPlus_RegisterServiceResp.success === false ))
                dispatch(EnrollmentRegisterServiceInit({ source }));
        }
    }, [dispatch,
        UserAccount.success,
        BOCDeviceCapabilityResult.success,
        BrotherPlus_RegisterServiceResp,
        IsBrotherPlus_Signup,
        source
     ] )

    useEffect(() => {
        if ( VerifyPreEnrollmentInfoResp.success && UserAccount.success && BOCDeviceCapabilityResult.success ) {
            WEB_handleSelectedPlanLocalData('Set', VerifyPreEnrollmentInfoResp.data?.plans?.[0]);
            if((EnrollmentResponse.loading === false 
                && EnrollmentResponse.success === false 
                && !Object.keys(EnrollmentResponse.data).length
            )) {
                let offers = getUserDataByKey("marketingEmails");
                const userData = getUserData()
                const shipping_address_from_managesubscription = WEB_handleLocalData('Get', LOCALSESSIONDATAKEYS.WEB_SHIPPING_ADDRESS)
                let shipping_address;
                if (userData?.shipping_address?.addressLine1) {
                    shipping_address = {
                        address: getUserDataByKey("addressLine1", 'shipping_address'),
                        addressLine2: getUserDataByKey("addressLine2", 'shipping_address'),
                        city: getUserDataByKey("cityTown", 'shipping_address'),
                        postcode: getUserDataByKey("postCode", 'shipping_address'),
                        country: getUserDataByKey("country", 'shipping_address'),
                        company: getUserDataByKey("companyName", 'shipping_address'),
                        province: getUserDataByKey("state", 'shipping_address')
                    }
                }
                else if (shipping_address_from_managesubscription?.street1) {
                    shipping_address = {
                        address: shipping_address_from_managesubscription?.street1,
                        addressLine2: shipping_address_from_managesubscription?.street2,
                        city: shipping_address_from_managesubscription?.city,
                        postcode: shipping_address_from_managesubscription?.postalCode,
                        country: shipping_address_from_managesubscription?.country,
                        company: shipping_address_from_managesubscription?.companyName,
                        province: shipping_address_from_managesubscription?.state
                    }
                }
                else {
                    shipping_address = {
                        address: getUserDataByKey("addressLine1", 'billing_address'),
                        addressLine2: getUserDataByKey("addressLine2", 'billing_address'),
                        city: getUserDataByKey("cityTown", 'billing_address'),
                        postcode: getUserDataByKey("postCode", 'billing_address'),
                        country: getUserDataByKey("country", 'billing_address'),
                        company: getUserDataByKey("companyName", 'billing_address'),
                        province: getUserDataByKey("state", 'billing_address')
                    }
                }

                offers = (offers === "true") ? true : false;
                const payloadInfo = {
                    accountDetails: {
                        personalDetails: {
                            firstName: getUserDataByKey("firstName", 'personal_details'),
                            lastName: getUserDataByKey("lastName", 'personal_details'),
                            emailAddress: getUserDataByKey("emailAddress", 'personal_details'),
                            offers: offers,
                            telephoneNumber: getUserDataByKey("telephoneNumber", 'personal_details'),
                            mobileNumber: getUserDataByKey("mobileNumber", 'personal_details')
                        },
                        shippingAddress: { ...shipping_address },
                        billingAddress: {
                            address: getUserDataByKey("addressLine1", 'billing_address'),
                            addressLine2: getUserDataByKey("addressLine2", 'billing_address'),
                            city: getUserDataByKey("cityTown", 'billing_address'),
                            postcode: getUserDataByKey("postCode", 'billing_address'),
                            country: getUserDataByKey("country", 'billing_address'),
                            company: getUserDataByKey("companyName", 'billing_address'),
                            province: getUserDataByKey("state", 'billing_address')
                        }
                    },
                    billingInfo: zrenderParams.zrenderParams,
                    selectedplan: WEB_handleSelectedPlanLocalData("Get")
                }
                const handlePayload = async (payloadInfo) => {
                    const payload = await handleSubscriptionOrderPayload(payloadInfo);
                    dispatch(Enrollment(payload));
                }
                handlePayload(payloadInfo);
            }
        }
    }, [
        dispatch,
        zrenderParams.zrenderParams,
        BOCDeviceCapabilityResult.success,
        IsBrotherPlus_Signup,
        VerifyPreEnrollmentInfoResp,
        EnrollmentResponse,
        BrotherPlus_RegisterServiceResp,
        UserAccount.success
    ])
    
    /*
     * Brother Plus enrollment — Step 1 of 3: Fetch current notification consent.
     *
     * Triggered once RegisterService API succeeds. Dispatches a GET request to
     * retrieve the user's existing notification consent details so that Step 2
     * can decide whether a PATCH update is required before navigating.
     */
    useEffect(() => {
        if (BrotherPlus_RegisterServiceResp.success) {
            consentUpdateDispatched.current = false;
            // Mark that THIS journey owns the upcoming GET response so Effect 2
            // ignores any userNotificationConsentDetails already sitting in Redux
            // from a prior enrollment in the same session.
            consentGetDispatched.current = true;
            dispatch(getUserNotificationConsentDetailsRequest());
        }
    }, [BrotherPlus_RegisterServiceResp.success, dispatch])

    /*
     * Brother Plus enrollment — Step 2 of 3: Evaluate consent and act.
     *
     * Runs once both RegisterService has succeeded and the GET consent response
     * has arrived (getConsentSuccess is true).
     *
     * - Calls evaluateConsent() to compare the user's current emailConsent
     *   value against what the enrolment source (WEB) expects.
     * - If an update is needed (shouldUpdate = true): dispatches a PATCH request
     *   to update the consent state; Step 3 will handle navigation once resolved.
     * - If no update is needed (shouldUpdate = false): navigates immediately via
     *   navigateOnEnrollmentSuccess() without waiting for a PATCH round-trip.
     */
    useEffect(() => {
        if (!BrotherPlus_RegisterServiceResp.success) return;
        if (!consentGetDispatched.current) return;
        if(getConsentError){
            consentGetDispatched.current = false;
            navigateOnEnrollmentSuccess();
            return;
        }
        if (getConsentSuccess) {
            consentGetDispatched.current = false;
            const { shouldUpdate, payload } = evaluateConsent({
                consentValue: emailConsentRef.current,
                enrolmentSource: WEB,
            });
            if (shouldUpdate) {
                consentUpdateDispatched.current = true;
                dispatch(updateUserNotificationConsentStateRequest(payload));
            } else {
                navigateOnEnrollmentSuccess();
            }
        }
    }, [
        BrotherPlus_RegisterServiceResp.success,
        getConsentError,
        getConsentSuccess,
        dispatch, 
        navigateOnEnrollmentSuccess
    ])

    /*
     * Brother Plus enrollment — Step 3 of 3: Navigate after consent PATCH resolves.
     *
     * Guards on consentUpdateDispatched.current (set in Effect 2) to ensure this
     * effect only acts when THIS journey dispatched the PATCH — preventing spurious
     * navigation from stale Redux state left over from a previous enrollment session.
     *
     * Navigation proceeds regardless of whether the PATCH succeeded or failed —
     * consent is best-effort and the enrollment itself has already completed
     * successfully at this point.
     */
    useEffect(() => {
        if (!consentUpdateDispatched.current) return;
        if (putConsentSuccess || putConsentError) {
            consentUpdateDispatched.current = false;
            navigateOnEnrollmentSuccess();
        }
    }, [
        putConsentSuccess,
        putConsentError,
        navigateOnEnrollmentSuccess
    ])

    /*
     * EcoPro enrollment — navigate on Enrollment API success.
     *
     * Fires when the standard EcoPro Enrollment API call succeeds. Passes the
     * 'web-signup' dataLayer event and the returned serialNumber to
     * navigateOnEnrollmentSuccess(), which stores the serial number locally,
     * shows the success overlay for 3 seconds, then routes to the dashboard
     * (or the next Add Device step if source is SOURCE_MY_DEVICE).
     */
    useEffect(() => {
        if (EnrollmentResponse.success) {
            dispatch(ResetStateDashboardPreEnrolInfo());
            navigateOnEnrollmentSuccess({
                dataLayerEvent: 'web-signup',
                serialNumber: EnrollmentResponse.data?.serialNumber,
            });
        }
        // eslint-disable-next-line
    }, [
        EnrollmentResponse.success,
        navigateOnEnrollmentSuccess
    ])

    if (ScmsTokenResult.error) {
        return <ErrorPage errorInfo={ScmsTokenResult.error} />
    }
    return (
        VerifyPreEnrollmentInfoResp.error ? 
            <div className={`device-not-connected-wrapper ${cname}`}>
                <ErrorPage errorInfo={VerifyPreEnrollmentInfoResp.error} webConnectionDashboardError={true} />
            </div>
            :
            UserAccount.error ?
                <div className={`device-not-connected-wrapper ${cname}`}>
                    <ErrorPage errorInfo={UserAccount.error} webConnectionDashboardError={true} />
                </div>
                :
                EnrollmentResponse.error ?
                    <div className={`device-not-connected-wrapper ${cname}`}>
                        <ErrorPage errorInfo={EnrollmentResponse.error} webConnectionDashboardError={true} />
                    </div>
                    :
                    BrotherPlus_RegisterServiceResp.error ?
                        <div className={`device-not-connected-wrapper ${cname}`}>
                            <ErrorPage errorInfo={BrotherPlus_RegisterServiceResp.error} webConnectionDashboardError={true} />
                        </div>
                        :
                        showUnsupportedFirmware ?
                            <DeviceNotConnected
                                header={t("DEVICE_STATUS_CHECK.FIRMWARE_STATUS_INFO")}
                                content={t('DASHBOARD_CONNECT_DEVICE.DEVICE_NOT_CONNECTED_CONTENT')}
                                btnText1={<img alt="andriod-app" src={appIconsImgSrc.androidAppIcon} role="button" height="50px" />}
                                btnText2={<img alt="ios-app" src={appIconsImgSrc.IOSAppIcon} role="button" height="40px" />}
                                handleConnectDevice={(e) => handleNavigateToAppStore(e)}
                                cname="download-app-section web-connect"
                            ></DeviceNotConnected>
                            :
                            showDeviceOffline ?
                                <div className='web-connection-device-offline'>
                                    <DisplayUpdateAccountConfirmation
                                        updateAddressHeader={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_HEADER_WEB_CONNECTION")}
                                        updateAddressInfo={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_INFO")}
                                        updateAddressBtn={t("ECOPRO_BTNS.RETRY")}
                                        onUpdateClick={() => recheckNetworkStatus()}
                                        image={deviceOffline}
                                    ></DisplayUpdateAccountConfirmation>
                                </div>
                                :
                                <>
                                    <div className={`device-not-connected-wrapper show-xs ${cname}`}>
                                        {(
                                            ScmsTokenResult.loading 
                                            || DeviceRegistrationResult.loading 
                                            || BOCDeviceCapabilityResult.loading 
                                            || UserAccount.loading 
                                            || EnrollmentResponse.loading 
                                            || BrotherPlus_RegisterServiceResp.loading
                                            || getConsentLoading
                                            || putConsentLoading
                                            || VerifyPreEnrollmentInfoResp.loading
                                        ) 
                                            &&
                                            <div className={`loader-overlay-wrapper`}>
                                                <Loader slowResponse={true} webConnection={true} setOverlay={true}></Loader>
                                            </div>
                                        }
                                        {
                                            showSuccessContent &&
                                            <div className='spinner-wrapper apply-overlay-bg device-successfully-connected'>
                                                <img src={DeviceConnectedSuccessfullyImage} alt="device-successfully-connected"></img>
                                                <div>{t("WEB_CONNECTION.CONNECTION_SUCCESS")}</div>
                                            </div>
                                        }
                                        <div className="printer-img-wrapper">
                                            <div className="printer-icon">
                                                <img
                                                    className="printer-icon-img"
                                                    src={printerIcon}
                                                    alt="device"
                                                />
                                            </div>
                                        </div>
                                        <div className="content">
                                            <h5>{header}</h5>
                                            <p>{subcontent}</p>
                                            <div className="web-connection-instruction">
                                                <div>{instruction1}</div>
                                                <div>{instruction2}</div>
                                                <div>{instruction3}</div>
                                            </div>

                                            <div className="enter-code-wrapper">
                                                <div className="enter-code-container">
                                                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => { handleOneTimeCode(e) }} value={oneTimeCode} placeholder={enterCodeLabel} />
                                                    <div className="device-not-connected-btn">
                                                        <EcoProButton cname="default" onBtnClick={(e) => handleCodeSubmit(e)} disabled={!oneTimeCode}>{codeSubmitText}</EcoProButton>
                                                    </div>
                                                </div>
                                            </div>
                                            <PinError />
                                            <p className="support-content">
                                                <Trans
                                                    i18nKey="WEB_CONNECTION.CONTACT_SUPPORT_TEAM"
                                                >
                                                    If you still can't connect your device, get in touch with our
                                                    <a href={contactUsLink} target="_blank"
                                                        rel="noreferrer"
                                                        id={UNIQUE_ID_GA.signup + "-contact-support-team"}>support team</a>.
                                                </Trans>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="device-not-connected-outer-wrapper show-lg">
                                        <div className={`device-not-connected-wrapper ${cname}`}>
                                            <div className="printer-img-wrapper">
                                                <div className="printer-icon">
                                                    <img
                                                        className="printer-icon-img"
                                                        src={printerIcon}
                                                        alt="device"
                                                    />
                                                </div>
                                            </div>
                                            <div className="content">
                                                {(
                                                    ScmsTokenResult.loading
                                                    || DeviceRegistrationResult.loading
                                                    || BOCDeviceCapabilityResult.loading
                                                    || UserAccount.loading
                                                    || EnrollmentResponse.loading
                                                    || BrotherPlus_RegisterServiceResp.loading
                                                    || getConsentLoading
                                                    || putConsentLoading
                                                    || VerifyPreEnrollmentInfoResp.loading
                                                ) &&
                                                    <div className={`loader-overlay-wrapper`}>
                                                        <Loader slowResponse={true} webConnection={true} setOverlay={true}></Loader>
                                                    </div>
                                                }
                                                {
                                                    showSuccessContent &&
                                                    <div className='spinner-wrapper apply-overlay-bg device-successfully-connected'>
                                                        <img src={DeviceConnectedSuccessfullyImage} alt="device-successfully-connected"></img>
                                                        <div>{t("WEB_CONNECTION.CONNECTION_SUCCESS")}</div>
                                                    </div>
                                                }
                                                <h5>{header}</h5>
                                                <p>{subcontent}</p>
                                                <div className="web-connection-instruction">
                                                    <div>{instruction1}</div>
                                                    <div>{instruction2}</div>
                                                    <div>{instruction3}</div>
                                                </div>
                                                <div className="enter-code-wrapper">
                                                    <div className="enter-code-container">
                                                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => { handleOneTimeCode(e) }} value={oneTimeCode} placeholder={enterCodeLabel} />
                                                        <div className="device-not-connected-btn">
                                                            <EcoProButton cname="default" onBtnClick={(e) => handleCodeSubmit(e)} disabled={!oneTimeCode}>{codeSubmitText}</EcoProButton>
                                                        </div>
                                                    </div>
                                                </div>
                                                <PinError />
                                                <p className="support-content">
                                                    <Trans
                                                        i18nKey="WEB_CONNECTION.CONTACT_SUPPORT_TEAM"
                                                    >
                                                        If you still can't connect your device, get in touch with our
                                                        <a href={contactUsLink} target="_blank"
                                                            rel="noreferrer"
                                                            id={UNIQUE_ID_GA.signup + "-contact-support-team"}>support team</a>.
                                                    </Trans>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </>

    );
};

export default WebConnection;